import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';
export const types = {
  inPanel: PropTypes.bool.isRequired,
  inModal: PropTypes.bool.isRequired
};
export const defaultPanelContext = {
  inPanel: false,
  inModal: false
};
export const PanelContext = /*#__PURE__*/createContext(defaultPanelContext);
export function usePanelContext() {
  return useContext(PanelContext);
}
export const {
  Consumer,
  Provider
} = PanelContext;
export const propType = PropTypes.shape(types);